/**
 * Suppresses the page_view artifacts emitted while the player is being opened.
 *
 * Launching a video from Home or My List opens the player as an overlay: the
 * underlying screen can blur then regain focus, which re-fires its
 * `useFocusEffect` and sends a page_view immediately before the
 * dv_content_consumption event. Those page_views describe no real navigation.
 *
 * The window is deliberately short: it only has to cover the open transition,
 * so a long player session can never swallow a legitimate page_view. The
 * suppression is also released as soon as the player starts closing, so the
 * page_view sent when the origin screen regains focus after the player closes
 * is kept (intended behavior).
 */
const SUPPRESSION_WINDOW_MS = 5000;

let suppressedAt: number | null = null;

export function suppressPageViewsForPlayerLaunch(): void {
  suppressedAt = Date.now();
}

export function releasePageViewSuppression(): void {
  suppressedAt = null;
}

export function isPageViewSuppressed(): boolean {
  if (suppressedAt === null) {
    return false;
  }
  if (Date.now() - suppressedAt > SUPPRESSION_WINDOW_MS) {
    suppressedAt = null;
    return false;
  }
  return true;
}
